export default "__VITE_ASSET__CcyNIST$__"